/**
 * Next.jsのAPI Routesなど、サーバーサイドでインポートする際に
 * クライアントサイドのHooks(swr等)への依存によるビルドエラーを避けるため、
 * 定数データのみをこのファイルに分離しています。
 */
interface AppGroup {
  label: string;
  type: "group";
  children: App[];
}

export type AppLinkKey =
  | "core"
  | "checkin"
  | "checkinV2"
  | "systems"
  | "cleaning"
  | "users"
  | "messages"
  | "sumyca"
  | "agents"
  | "workflows";

interface AppLink {
  label: string;
  type: "link";
  key: AppLinkKey;
}

export type App = AppGroup | AppLink;

export const apps: App[] = [
  {
    label: "m2m Series",
    type: "group",
    children: [
      {
        label: "Core 施設管理",
        type: "link",
        key: "core",
      },
      {
        label: "Checkin ゲストチェックイン",
        type: "link",
        key: "checkin",
      },
      {
        label: "Systems Airbnb連携",
        type: "link",
        key: "systems",
      },
      {
        label: "Cleaning 清掃管理",
        type: "link",
        key: "cleaning",
      },
      {
        label: "Users アカウント管理",
        type: "link",
        key: "users",
      },
      {
        label: "Checkin(v2) ゲストチェックイン",
        type: "link",
        key: "checkinV2",
      },
      {
        label: "Messages Bookingメッセージ",
        type: "link",
        key: "messages",
      },
    ],
  },
  {
    label: "Sumyca マンスリープラットフォーム",
    key: "sumyca",
    type: "link",
  },
  {
    label: "Agents BQ連携のAIエージェント",
    key: "agents",
    type: "link",
  },
  {
    label: "Workflows ワークフロー管理",
    key: "workflows",
    type: "link",
  },
];
